<template>
	<div>
		<formmain ref="formmain" :windowType="windowType" :width="width" :height="height"
			:flowprogressid="flowprogressid" :loading="loading" @show="show" @hide="hide">
			<template #title>
				<div>{{extra.title?extra.title:title}}</div>
			</template>
			<template #main>
				<div :ref="name+'_form'" style="margin-top: 20px;"></div>
			</template>
			<template #footer>
				<vxe-button status="success" content="预览" @click="preview"></vxe-button>
				<vxe-button status="" content="取消" @click="hide"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit()"></vxe-button>
			</template>
		</formmain>
		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" />
		<departmentnodeconfig v-if="formrule" :configdata="configdata" :formrule="formrule" ref="departmentnodeconfig" @success="departmentnodeconfigSubmit" />	
	</div>
</template>
<style scoped>

</style>
<script>
	const formRes = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "650",
			"fApi": [],
			"rule": [{
					"type": "$input",
					"field": "name",
					"title": "名称",
					"value": "",
					"hidden": false,
					"props": [],
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				// {
				// 	"type": "$input",
				// 	"field": "sourcename",
				// 	"title": "来源",
				// 	"value": "",
				// 	"hidden": false,
				// 	"props": [],
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// },
				{
					"type": "$input",
					"field": "title",
					"title": "标题",
					"value": "",
					"hidden": false,
					"props": [],
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				// {
				// 	"type": "select",
				// 	"field": "componenttype",
				// 	"title": "类型",
				// 	"value": 2,
				// 	"options": [{
				// 			"value": 1,
				// 			"label": "系统预置"
				// 		},
				// 		{
				// 			"value": 2,
				// 			"label": "用户定义"
				// 		}
				// 	],
				// 	"hidden": false,
				// 	"props": {
				// 		"initValue": null
				// 	},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// },
				{
					"type": "$input",
					"field": "controll",
					"title": "控制器",
					"value": "",
					"hidden": false,
					"props": [],
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "select",
					"field": "listtype",
					"title": "查看模式",
					"value": 1,
					"options": [{
							"value": 1,
							"label": "普通模式"
						},
						{
							"value": 2,
							"label": "分级模式(严格)"
						},
						{
							"value": 3,
							"label": "分级模式(宽松)"
						},
						{
							"value": 4,
							"label": "分级模式(共享)"
						}
					],
					"hidden": false,
					"props": {
						"initValue": null
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$department",
					"field": "departmentnode",
					"title": "节点部门",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true,
						"multiple": true,
						"checkStrictly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},				
				{
					"type": "$inputButton",
					"field": "departmentnodeconfig",
					"title": "节点配置",
					"value": null,
					"hidden": false,
					"props": {
						"multiple": true,
						"checkStrictly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-button-group",
					"title": "",
					"field": "buildGroup",
					"children": [{
							"type": "el-button",
							"title": "",
							"field": "relation",
							"children": [
								"数据关系"
							],
							"props": {
								"type": "danger"
							}
						},
						{
							"type": "el-button",
							"title": "",
							"field": "build",
							"children": [
								"构建"
							],
							"style": {
								"marginLeft": "20px"
							},
							"props": {
								"type": "primary"
							}
						}
					],
					"style": {
						"marginLeft": "75px"
					},
					"col": {
						"span": 24
					}
				},
				{
					"type": "$vjsoneditor",
					"field": "rule",
					"title": "表单",
					"value": null,
					"labelWidth": "0px",
					"hidden": false,
					"props": {
						"height": "380px",
						"options": {
							"mode": "code"
						}
					},
					"col": {
						"span": 21,
						"offset": 1
					},
					"style": {
						"marginTop": "6px"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 10,
							"offset": 1
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}


	import formmain from '@_system/components/base/formmain.vue'
	import formBase from '@_system/components/base/form.vue'
	import formPreview from './preview.vue'
	import departmentnodeconfig from './departmentnodeconfig/index.vue'
	export default {
		name: 'formForm',
		extends: formBase,
		props: {

		},
		data() {
			return {
				rule:null,
				formrule:null,
				configdata:[],
				formModule: {					
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
				}
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				new Promise((resolve) => {
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {
					let res = JSON.parse(JSON.stringify(formRes))
					this.rule = res.rule
					if (this.extra.defaultvalue) {
						for (let i in this.extra.defaultvalue) {
							for (let j in this.rule.rule) {
								if (this.rule.rule[j].field == i) {
									this.rule.rule[j].value = this.extra.defaultvalue[i]
								}
							}
						}
					}
					this.title = res.title
					this.width = res.rule.width
					this.height = res.rule.height

					this.openwindow()

				})
			},
				


			regestEvent(rule, fApi) {
				fApi.updateRule('build', {
					on: {
						click: this.build
					}
				})
				fApi.updateRule('relation', {
					on: {
						click: this.relation
					}
				})
				fApi.updateRule('departmentnodeconfig', {
					on: {
						inputButtonclick: this.departmentnodeconfig
					}
				})
			},
			beforeRender(res){
				res.departmentnodeconfig = res.departmentnodeconfig?JSON.stringify(res.departmentnodeconfig):null
			},
			departmentnodeconfig(){	
				this.formrule = this.fApi.getValue('rule')
				this.configdata = this.fApi.getValue('departmentnodeconfig')
				if(!this.formrule){
					this.$message.error('表单规格不存在')
					return
				}
				this.$nextTick(()=>{					
					this.$refs.departmentnodeconfig.modal_show()
				})				
			},
			departmentnodeconfigSubmit(e){
				if(!e.data){
					this.fApi.setValue('departmentnodeconfig', null)
					this.fApi.setValue('departmentnode', null)
				}else{
					let departmentnode = JSON.parse(e.data).map((item)=>{
						return item.departmentnode
					})
					this.fApi.setValue('departmentnodeconfig', e.data)
					this.fApi.setValue('departmentnode', departmentnode)
				}
			},
			build() {
				let controll = this.fApi.getValue('controll')
				let componenttype = this.fApi.getValue('componenttype')
				if (!controll) {
					this.$message.error('请填写控制器')
				} else if (componenttype == '') {
					this.$message.error('请选择类型')
				} else if (componenttype == 1) {
					this.$message.error('只允许构建用户定义')
				} else {
					this.loading = true
					this.$api[this.name].build(controll, {
						controllname: this.fApi.getValue('name')
					}).then((res) => {
						this.loading = false
						let value = this.fApi.getValue('rule')
						if (value) {
							value.rule = res.rule
						} else {
							value = res
						}
						this.fApi.setValue('rule', value)
						this.$message.success('构建成功')
					},()=>{
						this.loading = false
					})
				}
			},
			relation() {
				let controll = this.fApi.getValue('controll')
				let name = this.fApi.getValue('name')
				// let sourcename = this.fApi.getValue('sourcename')
				let title = this.fApi.getValue('title')
				let componenttype = this.fApi.getValue('componenttype')
				if (name == '') {
					this.$message.error('请填写名称')
				} else if (!controll) {
					this.$message.error('请填写控制器')
				} else if (componenttype == '') {
					this.$message.error('请选择类型')
				} else if (componenttype == 1) {
					this.$message.error('只允许创建用户定义')
				} else {
					let res = this.$router.resolve({
						name: 'update',
						query: {
							name: 'relation',
							id: 0,
							controlltype: 2,
							windowName: '编辑数据关系',
							moduletype: 'system',
							extra: encodeURIComponent(JSON.stringify({
								title:'编辑数据关系（' + title + '）',
								controll: controll,
								name: name,
								// sourcename: sourcename
							}))
						}
					})
					let win = window.open(res.href, this.moduleName + 'update',
						this.$store.state.system.windowConfig)
					win.onload = () => {

					}
					// import('@_system/components/forms/form/relation/form.vue').then((res) => {
					// 	this.formModule = {
					// 		component: res.default,
					// 		name: 'relation',
					// 		show: true,
					// 		controlltype: 1,
					// 		extra: {
					// 			controll: controll,
					// 			name: name
					// 		}
					// 	}
					// })
				}
			},
			beforeSubmit(formData, next) {
				
				let parents = []
				formData.rule = JSON.stringify(formData.rule)
				//formData.departmentnodeconfig = formData.departmentnodeconfig?JSON.parse(formData.departmentnodeconfig):null
				if(Array.isArray(formData.departmentnode) && formData.departmentnode.length!=0){
					formData.departmentnode.forEach((item)=>{
						let departmentparents = window.systemMethods.findparentBydepartmentid(window.systemData.department,item)
						parents.push(departmentparents[departmentparents.length-1])
					})
				}
				
				let hasDuplicates = new Set(parents).size !== parents.length
				
				if(!hasDuplicates){
					next()
				}else{
					next()
					//this.$message.error('节点部门根节点不能相同')
				}
				

			},
			preview() {
				let rule = this.fApi.getValue('rule')
				let title = this.fApi.getValue('title')
				if (rule && rule.width && rule.height) {
					import('./preview.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: '',
							show: true,
							controlltype: 1,
							extra: {
								rule: rule,
								title: title
							}
						}
					})
				}
			},
			formBack() {
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
			}
			// submit() {
			// 	this.fApi.submit((formData) => {
			// 		formData.rule = JSON.stringify(formData.rule)
			// 		if (this.id == 0) {
			// 			this.save(formData)
			// 		} else {
			// 			this.update(formData)
			// 		}
			// 	})
			// }
		},
		components: {
			formmain,
			formPreview,
			departmentnodeconfig
		}
	}
</script>
